export const CREATE_ATTRIBUTE = 'organizations/users/attributes/create/CREATE'
export const CREATE_ATTRIBUTE_SUCCESS = `${CREATE_ATTRIBUTE}_SUCCESS`
